import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import get from 'lodash/get';
import { FooterNew as Footer } from '@comicrelief/component-library';

// This is the new Footer for 2026. At time of writing it is an amended copy of the other Footer.

export default () => {
  const data = useStaticQuery(graphql`
      query FooterQuery {
        contentfulFooterMenu {
          title
          legalTextLong {
            legalTextLong
          }
          copyrightTextLong {
            copyrightTextLong
          }
          showFacebookSocialIcon
          showInstagramSocialIcon
          showXSocialIcon
          showTikTokSocialIcon
          showYouTubeSocialIcon
          showEmailSignUp
          primaryLinksList {
            ... on ContentfulPageArticle {
              title
              path
              internal {
                type
              }
            }
            ... on ContentfulPageLandingPage {
              title
              path
              internal {
                type
              }
            }
            ... on ContentfulComponentLink {
              id
              title
              url
              internal {
                type
              }
              reference {
                path
              }
            }
            ... on ContentfulPageDefault {
              title
              path
              internal {
                type
              }
            }
          }
          secondaryLinksList {
            ... on ContentfulPageArticle {
              title
              path
              internal {
                type
              }
            }
            ... on ContentfulPageLandingPage {
              title
              path
              internal {
                type
              }
            }
            ... on ContentfulComponentLink {
              id
              title
              url
              internal {
                type
              }
              reference {
                path
              }
            }
            ... on ContentfulPageDefault {
              title
              path
              internal {
                type
              }
            }
          }
        }
      }
    `);

  const footerMenu = get(data, 'contentfulFooterMenu');

  const onNewsletterSubmit = (email) => {
    if (email) {
      window.sessionStorage.setItem('emailSignupCarriedOverEmail', email);
    }

    window.open('/newsletter-sign-up/', '_blank');

    // The new tab receives a copy of sessionStorage at creation, so this
    // cleans it up here because it's no longer needed.
    if (email) {
      window.sessionStorage.removeItem('emailSignupCarriedOverEmail');
    }
  };

  // Ensure any falsy 'null' coming from an unset CMS field isn't construed
  // as false, seeing as we want to show the ESU by default:
  const showEsu = footerMenu?.showEmailSignUp !== false;

  return (
    <Footer
      primaryLinksList={footerMenu?.primaryLinksList || []}
      secondaryLinksList={footerMenu?.secondaryLinksList || []}
      legalText={footerMenu?.legalTextLong?.legalTextLong}
      copyrightText={footerMenu?.copyrightTextLong?.copyrightTextLong}
      campaign="Comic Relief"
      showFundraisingRegulatorLogo
      showFacebookSocialIcon={footerMenu?.showFacebookSocialIcon}
      showInstagramSocialIcon={footerMenu?.showInstagramSocialIcon}
      showXSocialIcon={footerMenu?.showXSocialIcon}
      showTikTokSocialIcon={footerMenu?.showTikTokSocialIcon}
      showYouTubeSocialIcon={footerMenu?.showYouTubeSocialIcon}
      onNewsletterSubmit={onNewsletterSubmit}
      showEmailSignup={showEsu}
    />
  );
};
